export interface CompletedDocumentDownloadPreparation {
  downloadUrl: string;
}

export function parseCompletedDocumentDownloadPreparation(
  payload: unknown
): CompletedDocumentDownloadPreparation {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new Error('Invalid completed document download response.');
  }

  const downloadUrl = (payload as Record<string, unknown>).download_url;
  if (typeof downloadUrl !== 'string') {
    throw new Error('Invalid completed document download response.');
  }

  let parsedUrl: URL;
  try {
    parsedUrl = new URL(downloadUrl);
  } catch {
    throw new Error('Invalid completed document download response.');
  }

  if (parsedUrl.protocol !== 'https:') {
    throw new Error('Invalid completed document download response.');
  }

  return { downloadUrl };
}
